import { UsersView } from "./UsersView";
import { FC } from "react";

export const UsersViewContainer: FC = () => {
  return <UsersView />;
};
